import {
  GETCUSTOMERWALLETCURRENCYLIST_SUCCESS,
  GETCUSTOMERWALLETCURRENCYLIST_FAILED,
  RESET_GETCUSTOMERWALLETCURRENCYLIST,
  LOADING_GETCUSTOMERWALLETCURRENCYLIST,
  NETWORK_ERROR_GETCUSTOMERWALLETCURRENCYLIST,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetCustomerWalletCurrencyList = () => {
  return { type: RESET_GETCUSTOMERWALLETCURRENCYLIST };
};

const getCustomerWalletCurrencyList =
  (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETCUSTOMERWALLETCURRENCYLIST });
    await partnerServices
      .post("getCustomerWalletCurrencyList", userData, { headers: { AuthToken: authTokenIs } })
      .then((res) => {
        switch (res.status) {
          case 200:
            dispatch(getCustomerWalletCurrencyListsuccess(res.data));
            break;
          default:
            dispatch(getCustomerWalletCurrencyListFailed(res.data));
            break;
        }
      })
      .catch((err) => {
        dispatch({
          type: NETWORK_ERROR_GETCUSTOMERWALLETCURRENCYLIST,
          payload: err,
        });
      });
  };
function getCustomerWalletCurrencyListsuccess(data) {
  return {
    type: GETCUSTOMERWALLETCURRENCYLIST_SUCCESS,
    payload: data,
  };
}
function getCustomerWalletCurrencyListFailed(data) {
  return {
    type: GETCUSTOMERWALLETCURRENCYLIST_FAILED,
    payload: data,
  };
}

export { resetCustomerWalletCurrencyList, getCustomerWalletCurrencyList };
